import axios from 'axios';
import { prop } from 'ramda';

export const handleExecuteRedirect = async (redirectUrl, customProtocol, loadingOff = () => {}) => {
  let attemptCount = 1;
  async function fetchRedirect() {
    try {
      const response = await axios.get(`${redirectUrl}&defaultRedirect=false`);
      const { status, headers } = response || {};
      if (status === '201' || status === 201 || headers.status === '201' || headers.status === 201) {
        const customLocation = prop('location', headers);
        if (customLocation) {
          window.location.replace(customLocation);
          loadingOff();
        }
      }
    } catch(e) {
      setTimeout(() => {
        attemptCount = attemptCount + 1
        if (attemptCount < 4) {
          fetchRedirect();
        } else {
          window.location.assign(redirectUrl)
        }
      }, attemptCount * 1500)
      return;
    }

  }

  if (customProtocol) {
    await fetchRedirect();
  } else {
    window.location.assign(redirectUrl);
    loadingOff();
  }
}